import LINEITEMS from "./LINEITEMS";

export default {
  id: 'orders',
  name: 'Orders',
  singular_name: 'Order',
  fields: [
    {
      displayName: 'Merchant',
      id: 'merchant_name',
      type: 'text'
    },
    {
      displayName: 'Date',
      id: 'created_at',
      type: 'date'
    },
    {
      displayName: 'Total',
      id: 'total',
      type: 'dollar'
    },
    {
      displayName: 'Line Items',
      id: 'lineItems',
      type: 'array',
      schema: LINEITEMS
    }
  ]
}